import { useState } from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { siteInfo, teamMembers } from "@/mocks/site";
import Breadcrumb from "@/components/base/Breadcrumb";

const values = [
  {
    icon: "ri-shield-check-line",
    title: "专业",
    desc: "严谨整理每一份角色资料，考据来源，尊重作品本身。"
  },
  {
    icon: "ri-stack-line",
    title: "丰富",
    desc: "角色、资讯、专题、社区，一站式满足你的全部内容需求。"
  },
  {
    icon: "ri-heart-3-line",
    title: "有温度",
    desc: "我们不只是搬运资料，更希望传递对二次元文化真实的热爱。"
  }
];

const stats = [
  { value: "560+", label: "收录角色" },
  { value: "1,240+", label: "资讯文章" },
  { value: "3,800+", label: "社区话题" },
  { value: "50w+", label: "累计访问" }
];

export default function About() {
  useSeo({
    title: "关于我们 - 萝莉动漫主题站",
    description:
      "了解萝莉动漫主题站的品牌定位、团队与联系方式。我们专注打造专业、丰富、有温度的二次元萝莉文化内容平台。",
    keywords: "关于我们,萝莉动漫主题站,团队介绍,联系方式,二次元平台"
  });

  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(siteInfo.email);
    } catch {
      const input = document.createElement("input");
      input.value = siteInfo.email;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div>
      <div className="border-b border-background-200 bg-secondary-50">
        <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-4 text-3xl text-foreground-950 md:text-4xl">
            关于萝莉动漫主题站
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {siteInfo.slogan}
          </p>
        </div>
      </div>

      <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-flag-2-line"></i>
              网站定位
            </span>
            <h2 className="mt-4 text-2xl text-foreground-950 md:text-3xl">我们是谁</h2>
            <p className="mt-4 text-sm leading-loose text-foreground-700">{siteInfo.intro}</p>
            <p className="mt-3 text-sm leading-loose text-foreground-700">{siteInfo.mission}</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="mb-3 flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950">{v.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-background-200 bg-background-100/70">
        <div className="mx-auto grid max-w-[1280px] grid-cols-2 gap-6 px-4 py-10 md:grid-cols-4 md:px-6 md:py-12">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-3xl text-primary-600 md:text-4xl">{s.value}</p>
              <p className="mt-2 text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="mb-6 text-center">
          <h2 className="text-2xl text-foreground-950 md:text-3xl">我们的团队</h2>
          <p className="mt-2 text-sm text-foreground-600">
            一群热爱二次元文化、愿意认真对待每一份内容的人
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {teamMembers.map((m) => (
            <div
              key={m.name}
              className="flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-6 text-center"
            >
              <div className="h-20 w-20 overflow-hidden rounded-full border-2 border-primary-200 bg-background-100">
                <img src={m.avatar} alt={`${m.name} ${m.role}`} className="h-full w-full object-top" />
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{m.name}</h3>
              <span className="mt-1 rounded-full bg-secondary-100 px-3 py-0.5 text-xs text-secondary-700">
                {m.role}
              </span>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-background-200 bg-accent-50">
        <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-customer-service-2-line"></i>
                联系方式
              </span>
              <h2 className="mt-4 text-2xl text-foreground-950 md:text-3xl">随时欢迎联系我们</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                无论是内容投稿、合作洽谈，还是单纯的建议与鼓励，都欢迎随时找到我们。我们珍惜每一份来信。
              </p>

              <div className="mt-6 space-y-3">
                <div className="flex flex-wrap items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-mail-line text-lg"></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs text-foreground-500">邮箱</p>
                    <p className="truncate text-sm text-foreground-900">{siteInfo.email}</p>
                  </div>
                  <button
                    onClick={handleCopyEmail}
                    className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
                  >
                    <i className={copied ? "ri-check-line text-primary-600" : "ri-file-copy-line"}></i>
                    {copied ? "已复制" : "复制"}
                  </button>
                </div>

                {[
                  { icon: "ri-weibo-fill", label: "微博", value: siteInfo.weibo },
                  { icon: "ri-bilibili-fill", label: "哔哩哔哩", value: siteInfo.bilibili },
                  { icon: "ri-qq-fill", label: "QQ 群", value: siteInfo.qq }
                ].map((s) => (
                  <div
                    key={s.label}
                    className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                      <i className={`${s.icon} text-lg`}></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{s.label}</p>
                      <p className="text-sm text-foreground-900">{s.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <p className="mb-3 flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-map-pin-2-line text-primary-500"></i>
                办公地址
              </p>
              <p className="text-sm text-foreground-700">{siteInfo.address}</p>
              <div className="mt-4 overflow-hidden rounded-lg border border-background-200">
                <iframe
                  title="萝莉动漫主题站办公地址地图"
                  src="https://iuatbmy.cn/maps?q=Shanghai&output=embed"
                  className="h-64 w-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <Link
                to="/community"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
              >
                <i className="ri-chat-3-line"></i>
                去社区畅聊
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}